import { gql } from '@apollo/client';

export const DELETE_OBJECTIVE_MUTATION = gql`
    mutation deleteObjective($input: DeleteObjectiveInput!) {
        result: deleteObjective(input: $input) {
            affectedRows
        }
    } 
`;
